module.exports = "<p>\n  admin-see-message-dialog works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/dialogs/admin-see-message-dialog/admin-see-message-dialog.component.html
// module id = ../../../../../src/app/components/admin/components/dialogs/admin-see-message-dialog/admin-see-message-dialog.component.html
// module chunks = main